export const COLORS = {
    appGreen: '#00C853',
    appOrange: '#FFB300',
    appGrey: '#757575',
    appPurple: '#E1BEE7',
    appPink: '#F8BBD0',
    donut: {
        background: "#DADFE1",
        inhale: "#19B5FE",
        full: "#EF4836",
        exhale: "#3FC380",
        empty: "#9B59B6"
    }
}